const discountModal = document.querySelector(".discount-modal");
if (!discountModal) return;

const lastDiscountCode = localStorage.getItem("lastDiscountCode");

function getCookieValue(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

const urlDiscountCookie = getCookieValue("discount_code");

let newDiscountCode = "";
if (current_discounts && current_discounts.length > 0) {
    current_discounts.forEach(discount => {
        if (discount != lastDiscountCode) {
            newDiscountCode = discount;
        }
    })
} else if (urlDiscountCookie) {
    newDiscountCode = urlDiscountCookie;
}

if (newDiscountCode != "" && newDiscountCode != lastDiscountCode) {
    sessionStorage.removeItem('discount_modal_shown')
}

if (!sessionStorage.getItem('discount_modal_shown') && newDiscountCode != "") {
    localStorage.setItem("lastDiscountCode", newDiscountCode);
    sessionStorage.setItem("discount_modal_shown", "true");

    discountModal.open();
    discountModal.querySelector("[data-discount]").textContent = newDiscountCode;

    let discountNr = "";
    let match = newDiscountCode.match(/\d+/);
    if (match != null) discountNr = match[0];
    const valueTextElements = discountModal.querySelectorAll("[data-value]");

    if (!valueTextElements.length) {
        return;
    }

    if (discountNr == "") {
        discountModal.querySelector("[data-discount-value-text]").remove();
    }

    // format ex 5 -> 05 if needed with discountNr.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }
    valueTextElements.forEach(el => el.textContent = discountNr);
}